// extracted by mini-css-extract-plugin
export default {"wrapper":"Confirm_wrapper__e7z7S","controls":"Confirm_controls__DUaU5","triangle":"Confirm_triangle__Xer+Z"};